<h1 mat-dialog-title>{{ data.document.displayName }}</h1>
<div mat-dialog-content>
    <p *ngIf="data.message; else default">{{ data.message }}</p>
    <ng-template #default>
        <p>Document is being updated.</p>
    </ng-template>
</div>
<div mat-dialog-actions class="form-footer">
    <button mat-button class="primary" (click)="close()">Close</button>
</div>
